import { useAtom } from 'jotai';
import * as React from 'react';

import { Merchant } from 'common/api-types/director';
import { invalidateCachedCountryCodes } from 'common/state/countryState';
import { invalidateCachedWarehouse } from 'common/state/warehouseState';
import { warpMerchantAtom } from 'common/state/warpMerchantState';

export function useWarpMerchant() {
  const [cachedMerchant, setCachedMerchant] = useAtom(warpMerchantAtom);

  const setMerchant = React.useCallback(
    (merchant: Merchant | null) => {
      if (isMerchant(merchant)) {
        setCachedMerchant(merchant);
      } else {
        setCachedMerchant(null);
      }
      invalidateCachedCountryCodes();
      invalidateCachedWarehouse();
    },
    [setCachedMerchant],
  );

  const getMerchant = React.useCallback(() => {
    if (cachedMerchant) {
      return cachedMerchant;
    }
    setCachedMerchant(null);
    return null;
  }, [setCachedMerchant, cachedMerchant]);

  const clear = () => setCachedMerchant(null);

  return {
    setMerchant,
    getMerchant,
    clear,
    merchant: cachedMerchant,
  };
}

function isMerchant(maybeMerchant: unknown): maybeMerchant is Merchant {
  return (
    typeof maybeMerchant === 'object' &&
    maybeMerchant !== null &&
    'id' in maybeMerchant &&
    'name' in maybeMerchant &&
    'code' in maybeMerchant
  );
}
